import React from "react";

import { ListItem } from "@material-ui/core";

import MenuItemCard from "components/MenuItemCard";
import makeStyles from "hooks/makeStyles";
import useMenuGroup from "hooks/useMenuGroup";

const useStyles = makeStyles(theme => ({
	root: {
		display: "block",
		padding: 0,
		[theme.breakpoints.up(480)]: {
			flex: "1",
			padding: "8px",
			display: "block"
		},
		[theme.breakpoints.up(769)]: {
			flex: "1 0 50%",
			padding: "8px",
			display: "block"
		}
	}
}));

interface Props {
	menuItemId: string;
}

const MenuGroupItem = ({ menuItemId }: Props) => {
	const classes = useStyles();
	const { menuItemById } = useMenuGroup();

	const item = menuItemById[menuItemId];

	return (
		<ListItem key={item.id} className={classes.root}>
			<MenuItemCard item={item} />
		</ListItem>
	);
};

export default MenuGroupItem;
